'use client';

const SESSION_KEY = 'blv_session_id';

export function getOrCreateSessionId(): string {
  if (typeof window === 'undefined') return '';
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = 'sess_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 9);
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

export function getSessionId(): string | null {
  if (typeof window === 'undefined') return null;
  return sessionStorage.getItem(SESSION_KEY);
}

export function clearSession(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(SESSION_KEY);
}

export function saveAnswersToSession(answers: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem('blv_questionnaire_answers', JSON.stringify(answers));
}

export function getAnswersFromSession(): Record<string, unknown> | null {
  if (typeof window === 'undefined') return null;
  const raw = sessionStorage.getItem('blv_questionnaire_answers');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
